/* Layout */
import Layout from '@/views/layout/Layout';
import MyOrderDetails from '@/views/myorder/details/index';
import EnterpriseOrder from '@/views/myorder/index';


const enterpriseOrderRouter = {
  path: '/manage/enterpriseorders',
  name: 'enterpriseorders',
  props: true,
  type: 'buyers',
  meta: {
    icon: 'order',
    requiresAuth: true,
    role: 'user',
    title: '企业订单',
    perms: ['EntOrder.List']
  },
  redirect: '/manage/enterpriseorders/all',
  component: Layout,
  hidden: false,
  children: [
    {
      path: ':orderState',
      name: 'myorderAll',
      component: EnterpriseOrder,
      meta: {
        title: '订单列表',
        icon: 'order',
        requiresAuth: true,
        perms: ['EntOrder.List']
      },
      hidden: false
    },
    {
      path: 'details/:orderId',
      name: 'myorderDetails',
      component: MyOrderDetails,
      meta: {
        title: '订单详情',
        icon: 'order',
        requiresAuth: true,
        currentActive: '/manage/enterpriseorders/all',
        perms: ['EntOrder.Get']
      },
      hidden: true
    }
  ]
};
export default enterpriseOrderRouter



// WEBPACK FOOTER //
// ./src/router/modules/enterpriseOrder.js